import "./NavBarResponsive.css";

export const NavBarResponsive = () => {
  return (
    <>
      <button id="turno">
        <a
          style={{ textDecoration: "none", color: "white" }}
          href={"https://miportal.curf.com.ar/TurnosOnLine"}
        >
          Sacar un turno
        </a>
      </button>
    </>
  );
};
